export const chartDialog = theme => ({
  margin: theme.spacing(2),
});

export const details = theme => ({
  ...theme.typography.body1,
  fontWeight: 700,
  [theme.breakpoints.up('md')]: {
    paddingBottom: theme.spacing(2),
  },
});

export const dialogContent = theme => ({
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(0, 2, 2, 1),
  },
});

export const dialogTitle = theme => ({
  padding: theme.spacing(1.5, 1, 0, 3),
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2, 2, 0, 3),
  },
});

export const dropdown = theme => ({
  marginBottom: theme.spacing(3),
});

export const select = theme => ({
  ...theme.typography.body1,
  fontWeight: 700,
  marginTop: 2,
  paddingBottom: theme.spacing(3),
});

export const viewButton = theme => ({
  alignSelf: 'flex-end',
  padding: theme.spacing(0, 0, 2),
});
